import { createSlice } from '@reduxjs/toolkit';
import {
  getAuthUser,
  setImage,
  logout,
  updateProfileDetails,
  updatePassword,
  userLoginActivity,
} from '../thunks/userThunks';
import { toast } from 'react-toastify';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    userDetails: {},
    userLoginActivity: [],
    isUserLoginActivityLoading: true,
    isLoading: true,
    error: null,
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder
        .addCase(getAuthUser.fulfilled, (state,action) => {
            state.userDetails = action.payload.user;
            state.error = null;
            state.isLoading = false;
        })
        .addCase(getAuthUser.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(getAuthUser.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(setImage.fulfilled, (state, action) => {
            // update the user image
            state.error = null;
            state.isLoading = false;
        })
        .addCase(setImage.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(setImage.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(logout.fulfilled, (state, action) => {
            state.error = null;
            state.isLoading = false;
        })
        .addCase(logout.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(logout.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(updateProfileDetails.fulfilled, (state, action) => {
            state.error = null;
            state.isLoading = false;
            if(action.payload && action.payload.user){
                state.userDetails = action.payload.user;
                toast.success(action.payload.success);
            } else {
                toast.error('There is some error while updating the profile');
            }
        })
        .addCase(updateProfileDetails.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
            toast.error(action.payload?.error);
        })
        .addCase(updateProfileDetails.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(updatePassword.fulfilled, (state, action) => {
            state.error = null;
            state.isLoading = false;
            toast.success(action.payload.success);

        })
        .addCase(updatePassword.pending, (state, action) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(updatePassword.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            const current_password_error = action.payload?.error?.current_password || action.payload?.errors?.current_password;
            const new_password_error = action.payload?.errors?.new_password || action.payload?.error?.new_password;
            if(current_password_error){ 
                toast.error(current_password_error.toString());
            }
            if(new_password_error){
                toast.error(new_password_error.toString())
            } 
        })
        .addCase(userLoginActivity.fulfilled, (state,action) => {
            state.userLoginActivity = action.payload;
            state.error = null;
            state.isUserLoginActivityLoading = false;
        })
        .addCase(userLoginActivity.pending, (state, action) => {
            state.isUserLoginActivityLoading = true;
            state.error = null;
        })
        .addCase(userLoginActivity.rejected, (state, action) => {
            state.isUserLoginActivityLoading = false;
            state.error = action.payload;
        })
    },
});

export const actions = userSlice.actions;
export default userSlice.reducer;
